import PersonService from '../services/Person.service';
import { observable, action } from 'mobx';

class PeopleStore {
  people = observable([]);
  initialFetchDone = observable.box(false);

  @action
  async fetchPeople() {
    if (this.isLoaded()) {
      return this.people;
    }

    try {
      this.initialFetchDone.set(true);
      const items = await PersonService.fetchPeople();
      if (items.isEmpty) {
        return [];
      }

      this.people.push(...items.firstItem.experts);
    } catch (e) {
      this.initialFetchDone.set(false);
      console.error('Failed to fetch people data', e);
      return null;
    }

    return this.people;
  }

  getPeopleByPositionType(position) {
    if (!position) {
      return this.people;
    }

    const filter = Array.isArray(position) ? position : [position];

    return this.people.filter(person =>
      person.positionType.find(p => filter.includes(p.codename))
    );
  }

  isLoaded() {
    return this.initialFetchDone.get();
  }
}

export default new PeopleStore();



// WEBPACK FOOTER //
// ./src/stores/People.store.js